import React from 'react';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Star06 from 'src/app/icons/Monospaced/Star/Star06';
import Heart from 'src/app/icons/Monospaced/Heart/Heart';
import Lightning02 from 'src/app/icons/Monospaced/Lightning/Lightning02';
import Repeat03 from 'src/app/icons/Monospaced/Repeat/Repeat03';
import HeadingAndSupportingText from 'src/app/molecules/HeadingAndSupportingText/HeadingAndSupportingText';
import Award03 from 'src/app/icons/Monospaced/Award/Award03';
import CodeSnippet02 from 'src/app/icons/Monospaced/CodeSnippet/CodeSnippet02';
import Arrow from 'src/app/icons/Monospaced/Arrow/Arrow';
import { ButtonProps } from 'atoms/Button/Button';
import { IconCardProps } from 'molecules/IconCard/IconCard';
import IconCardGrid from 'molecules/IconCardGrid/IconCardGrid';
import { TypographyProps } from 'atoms/Typography/Typography';

const FeaturesListPlayground = (): JSX.Element => {
  const baseHeadingProps = {
    size: 'lg',
    type: 'paragraph',
    color: 'text-primary',
    fontWeight: 'font-weight-semibold',
  } as TypographyProps;

  const baseSupportingTextProps = {
    size: 'md',
    type: 'paragraph',
    color: 'text-tertiary',
    fontWeight: 'font-weight-regular',
  } as TypographyProps;

  const baseButtonProps = {
    variant: 'brand-text-link',
    icon: (
      <Arrow
        color='var(--brand-500)'
        width={21}
        orientation='right'
      />
    ),
    iconPosition: 'right',
    size: 'md',
    children: 'Learn more',
  } as ButtonProps;

  const FEATURES_LIST_PLAYGROUND = [
    {
      direction: 'column',
      featuredIcon: {
        icon: <Repeat03 width={24} />,
      },
      heading: {
        ...baseHeadingProps,
        text: 'Automations',
      },
      supportingText: {
        ...baseSupportingTextProps,
        text: 'Sure, they help you save time. You can also shower members with confetti, unlock secret rewards, and dole out custom badges. ',
      },
      buttonProps: {
        ...baseButtonProps,
        href: '/product/automations',
      },
    },
    {
      direction: 'column',
      featuredIcon: {
        icon: <Lightning02 width={24} />,
      },
      heading: {
        ...baseHeadingProps,
        text: 'Streaks',
      },
      supportingText: {
        ...baseSupportingTextProps,
        text: 'Who’s on 🔥? Your members. Keeping a streak is a small but mighty incentive that keeps them coming back and hitting milestones. ',
      },
      buttonProps: {
        ...baseButtonProps,
        href: '/product/gamification',
      },
    },
    {
      direction: 'column',
      featuredIcon: {
        icon: <Star06 width={24} />,
      },
      heading: {
        ...baseHeadingProps,
        text: 'AI Cohost',
      },
      supportingText: {
        ...baseSupportingTextProps,
        text: 'Meet your new sidekick. It’s been trained on all things Mighty and community strategy and is at your fingertips as you build. ',
      },
      buttonProps: {
        ...baseButtonProps,
        href: '/product/ai',
      },
    },
    {
      direction: 'column',
      featuredIcon: {
        icon: <CodeSnippet02 width={24} />,
      },
      heading: {
        ...baseHeadingProps,
        text: '2,000+ Embeds',
      },
      supportingText: {
        ...baseSupportingTextProps,
        text: 'Got a podcast? Pop it in. Make a member map? Show it off. AI clone? They can hang. Your Mighty Network can hold your entire digital world. ',
      },
      buttonProps: {
        ...baseButtonProps,
        href: '/product/embeds-integrations',
      },
    },
    {
      direction: 'column',
      featuredIcon: {
        icon: <Heart width={24} />,
      },
      heading: {
        ...baseHeadingProps,
        text: 'Points & Recognitions',
      },
      supportingText: {
        ...baseSupportingTextProps,
        text: 'Give your members points. They spend them by recognizing other members for being awesome. Community’s a game, and everyone wins.',
      },
      buttonProps: {
        ...baseButtonProps,
        href: '/product/gamification',
      },
    },
    {
      direction: 'column',
      featuredIcon: {
        icon: <Award03 width={24} />,
      },
      heading: {
        ...baseHeadingProps,
        text: 'Badges',
      },
      supportingText: {
        ...baseSupportingTextProps,
        text: 'Joined the community? You get a badge. Posted 20 times? You get a badge. Crushed that course? You get a badge. Everybody gets a badge!',
      },
      buttonProps: {
        ...baseButtonProps,
        href: '/product/automations',
      },
    },
  ] as IconCardProps[];

  return (
    <Stack
      gap='spacing-7xl'
      direction='column'
    >
      <Grid>
        <Stack
          columns={8}
          columnsLg={12}
        >
          <HeadingAndSupportingText
            heading={{
              text: (
                <>
                  Thoughtful features, done just right? Change can be <i>fun</i>
                </>
              ),
              size: 'md',
              type: 'heading',
              color: 'text-primary',
              fontWeight: 'font-weight-semibold',
            }}
            supportingText={{
              text: 'Moving to Mighty unlocks a playground, not just a platform.',
              size: 'xl',
              type: 'paragraph',
              color: 'text-tertiary',
              fontWeight: 'font-weight-regular',
            }}
          />
        </Stack>
      </Grid>
      <Stack>
        <IconCardGrid itemsList={FEATURES_LIST_PLAYGROUND} />
      </Stack>
    </Stack>
  );
};

export default FeaturesListPlayground;
